import { render, staticRenderFns } from "./banners-news.vue?vue&type=template&id=95d4e024&"
import script from "./banners-news.vue?vue&type=script&lang=js&"
export * from "./banners-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports